<template>
  <ValidationObserver ref="pdd" v-slot="{ handleSubmit }">
    <common ref="common" />
    <v-card class="rounded-xl" v-if="dtls">
      <v-toolbar flat>
        <v-toolbar-title>
          <v-icon left>mdi-account</v-icon>Primary
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="closeDialog">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text class="overflow-80 pt-2">
        <ValidationProvider
          name="First Name"
          :rules="{ required: true, max: 10 }"
          v-slot="{ errors }"
        >
          <v-text-field
            :value="dtls.firstName"
            disabled
            outlined
            name="First Name"
            label="First name"
            :error-messages="errors"
            dense
            readonly
          >
          </v-text-field>
        </ValidationProvider>
        <ValidationProvider
          name="Last Name"
          v-slot="{ errors }"
          rules="required"
        >
          <v-text-field
            :value="dtls.lastName"
            outlined
            name="Last Name"
            label="Last name"
            :error-messages="errors"
            disabled
            readonly
            dense
          >
          </v-text-field>
        </ValidationProvider>
        <ValidationProvider
          name="DOB"
          v-slot="{ errors }"
          rules="required"
        >
        <DatePicker dense v-model="dtls.person.dateOfBirth" label="DOB" :max="maxDOB" :initalDate="maxDOB" :errorMessages="errors"/>
        </ValidationProvider>
        <ValidationProvider name="Mail" v-slot="{ errors }" rules="email">
          <v-text-field
            outlined
            name="Mail"
            label="Mail"
            :error-messages="errors"
            v-model="dtls.person.emailId"
            dense
          >
          </v-text-field>
        </ValidationProvider>
        <ValidationProvider name="PAN" v-slot="{ errors }" :rules="{regex:'^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$'}">
          <v-text-field
            outlined
            name="PAN"
            label="PAN"
            :error-messages="errors"
            v-model="dtls.person.panCardNo"
            dense
          >
          </v-text-field>
        </ValidationProvider>
        <ValidationProvider name="Group" v-slot="{ errors }" rules="required">
          <v-select
            v-model="selectedGroup"
            :items="groupList"
            return-object
            item-text="value"
            name="Group"
            label="Group"
            :error-messages="errors"
            outlined
            dense
          >
          </v-select>
        </ValidationProvider>
        <ValidationProvider
          name="Blood Group"
          v-slot="{ errors }"
          rules="required"
        >
          <v-select
            v-model="selectedBloodGroup"
            :items="bloodGroupList"
            return-object
            item-text="value"
            name="Blood Group"
            label="Blood Group"
            :error-messages="errors"
            outlined
            dense
          >
          </v-select>
        </ValidationProvider>
      </v-card-text>
      <v-card-actions class="d-flex justify-end px-6">
        <v-btn color="primary" dark @click="handleSubmit(save)">Save</v-btn>
      </v-card-actions>
    </v-card>
  </ValidationObserver>
</template>
<script>
import { callApi } from "@/api/others";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import dayjs from 'dayjs';
export default {
  components: {
    ValidationObserver,
    ValidationProvider,
    DatePicker: () => import("@/components/tools/toolbox/DatePicker.vue"),
    common: () => import("@/components/tools/common.vue"),
  },
  props: {
    mbr: Object,
  },
  data: () => ({
    dtls: {
      person: {},
    },
    groupList: [],
    bloodGroupList: [],
    maxDOB:dayjs().subtract(18,"years").format("YYYY-MM-DD")
  }),
  computed: {
    selectedGroup: {
      get: function() {
        return {
          id: this.dtls.memberGroupId,
          value: this.dtls.groupName,
        };
      },
      set: function(nv) {
        console.log("selectedGroup",nv);
        this.dtls.groupName = nv.value;
        this.dtls.memberGroupId = nv.id;
      },
    },
    selectedBloodGroup: {
      get: function() {
        return {
          id: this.dtls.bloodgrpId,
          value: this.dtls.bloodGroup,
        };
      },
      set: function(nv) {
        this.dtls.bloodGroup = nv.value;
        this.dtls.bloodgrpId = nv.id;
      },
    },
  },
  mounted() {
    this.clonembr();
    this.getNeccessary();
  },
  methods: {
    clonembr() {
      this.dtls = JSON.parse(JSON.stringify(this.mbr));
    },
    closeDialog() {
      this.$emit("closeDialog");
    },
    async getNeccessary() {
      await this.getLists("/api/wesupport/GeneralMaster/getAllbytype?type=BloodGroup").then((list)=>{this.bloodGroupList = list});
      await this.getLists("/api/wesupport/MemberGroup/autoBytype?searchQuery=&grouptype=0").then((list)=>{this.groupList = list});
    },
    getLists(url) {
      return new Promise((resolve, reject) => {
        let list = [];
        this.dpLoading = true;
        callApi(url, "get", "")
          .then((res) => {
            list = res.data;
            resolve(list);
          })
          .catch((err) => {
            this.$refs.common.ManageResponse(err.response);
            reject();
          })
          .finally(() => {
            this.dpLoading = false;
          });
      });
    },
    save() {
      console.log("this.dtls save", this.dtls);
      let url = "/api/wesupport/Member/PrimarySave";
      callApi(url, "post", this.dtls)
        .then((res) => {
          this.closeDialog();
          this.$emit("showResponse", res);
        })
        .catch((err) => {
          this.$emit("showResponse", err.response);
        });
    },
  },
};
</script>
<style>
.overflow-80 {
  max-height: 80vh;
  overflow: auto;
}
</style>
